import Layout from '../../components/layout/Layout'
import { ASSETS } from '@/constants/assets'
import ImageCard from '@/components/ui/image-card'

const EvolutionOfIdea = () => {
  return (
    <Layout>
      <div className="w-full max-w-4xl px-4 md:px-8 lg:px-12 py-12 space-y-6">
        <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-4">
          <h1 className="text-[2.488rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance]">
            Evolution of Idea
          </h1>
          <div className="text-muted-foreground text-[0.875rem] leading-[1.2]">
            January 15, 2024
          </div>
        </div>
        
        <p className="text-foreground text-[1.375rem] leading-[1.3] [text-wrap:balance]">
          At what point does an idea become a product?
        </p>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Writing Idea
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Digitize cards and letters memories.
          </p>
          <ImageCard 
            src={ASSETS.images.evolutionSketch1}
            alt="Initial concept sketches and notes"
            className="mt-6"
            withGlow
          />
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Concept Sketching
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Early explorations and hand-drawn concepts for visual elements.
          </p>
          <div className="grid grid-cols-2 gap-4 w-full mt-6">
            <ImageCard 
              src={ASSETS.images.evolutionSketch2}
              alt="Concept sketch 1"
              withGlow
            />
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Expand on Potential States
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Exploring various states and interactions within the visual system.
          </p>
          <div className="grid grid-cols-2 gap-4 w-full mt-6">
            <ImageCard 
              src={ASSETS.images.evolutionState1}
              alt="State flow diagram 1"
              isSquare
              withGlow
            />
            <ImageCard 
              src={ASSETS.images.evolutionState2}
              alt="State flow diagram 2"
              isSquare
              withGlow
            />
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Digital Sketch
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Translating hand-drawn concepts into digital form.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
            <ImageCard 
              src={ASSETS.images.mobileMock}
              alt="Digital sketch iteration 1"
            />
            <ImageCard 
              src={ASSETS.images.mobileMock}
              alt="Digital sketch iteration 2"
            />
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Digital Mock Prototype
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Hi-fidelity mockups and interactive prototypes.
          </p>
          <ImageCard 
            src={ASSETS.images.mobileMock}
            alt="High-fidelity prototype"
            className="mt-6"
          />
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Digital Interactive UX/UI
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Interactive elements and user interface components.
          </p>
          <div className="grid grid-cols-2 gap-4 w-full mt-6">
            <ImageCard 
              src={ASSETS.images.morphingDemo}
              alt="Interactive UI component 1"
              isSquare
            />
            <ImageCard 
              src={ASSETS.images.morphingDemo}
              alt="Interactive UI component 2"
              isSquare
            />
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-[1.953rem] font-semibold text-foreground font-sans tracking-[-0.025em] leading-[1.2] [text-wrap:balance] mb-8">
            Digital Demo Video
          </h2>
          <p className="text-foreground text-lg leading-relaxed">
            Final demonstration of the visual language system in action.
          </p>
          <video 
            src={ASSETS.videos.cardsDemo}
            className="w-[60%] mx-auto mt-6 rounded-2xl shadow-lg block"
            autoPlay
            loop
            muted
            playsInline
          />
          <p className="text-muted-foreground text-sm mt-2">
            Idea and video by <a href="https://x.com/samdape" target="_blank" rel="noopener noreferrer" className="text-foreground hover:underline">@samdape</a> (<a href="https://x.com/samdape/status/1875895881247121517" target="_blank" rel="noopener noreferrer" className="text-foreground hover:underline">Tweet</a>)
          </p>
        </div>
      </div>
    </Layout>
  )
}

export default EvolutionOfIdea 